<div class="order-container container-fluid">
    <div id="order{{orderView?.id}}" class="panel panel-default">

        <div class="panel-heading">
            <span class="pull-left"
                  translate="cart.order.history.order.number"></span>&nbsp;{{orderView?.id}}
            <a [routerLink]="ORDER_HISTORY_ROUTE"
               translate="cart.order.history.details.back"></a>
        </div>

        @if (!loading) {
            <div>
                <div class="panel-body">
                    <order-history-product-row class="order-summary-wrapper"
                                   (itemAdded)="addItemToCart($event, orderView.id)"
                                   [displayVolume]="shouldDisplayVolume"
                                   [headerLabels]="headerLabels"
                                   [displayAttributes]="productDisplayAttributes"
                                   [orderView]="orderView"></order-history-product-row>
                    <div class="flex-col-small order-1">
                        <div class="card">
                            <div class="card-header">
                                <span class="pull-left" translate="cart.order.history.order.status"></span>
                                <span translate="cart.order.history.order.status.last.updated"></span>
                            </div>
                            <div class="card-body">
                                <span class="text-capitalize fw-bold">{{'cart.order.history.order.status.' + orderView?.status.toLowerCase() | translate}}</span>
                                <span>{{orderView?.orderDate | usanadate: 'mediumDate':orderView?.warehouse?.timezone | async}}</span>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <span class="pull-left" translate="cart.order.history.order.source"></span>
                                <span translate="cart.order.history.order.placed"></span>
                            </div>
                            <div class="card-body">
                                <span translate="{{ 'cart.order.history.source.' + orderView?.source }}"></span>
                                <span>{{orderView?.orderDate | usanadate: 'mediumDate':orderView?.warehouse?.timezone | async}}</span>
                            </div>
                        </div>

                        @if (!!orderView?.bpsReference?.bpsNumber) {
                            <div class="card">
                                <div class="card-header">
                                    <span class="pull-left" translate="cart.order.history.bps.refernumber.text"></span>
                                </div>
                                <div class="card-body">
                                    @if (!!cashPSText) {
                                        <span [innerHTML]="cashPSText"></span>
                                    } @else {
                                        <span>
                                            {{orderView?.bpsReference?.bpsNumber}}
                                        </span>
                                    }
                                </div>
                            </div>
                        }
                        @if (!!orderView?.charity) {
                            <div class="card">
                                <div class="card-header">
                                    <span class="pull-left" translate="cart.order.history.charity.invoice.info"></span>
                                </div>
                                <div class="card-body">
                                    @if (!!orderView?.charity.id) {
                                        <span>
                                            <ul>
                                                <li translate="cart.order.history.charity.confirmation"></li>
                                                <li [translate]="'cart.checkout.charity.' + orderView?.charity.id"></li>
                                            </ul>
                                        </span>
                                    } @else {
                                        <span translate="cart.order.history.charity.custid.text"></span>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div class="flex-col-small  order-2">
                        <div class="card">
                            <div class="card-header">
                                <span class="pull-left" translate="cart.order.history.shipping.address"></span>
                            </div>
                            <div class="card-body">
                                <ul>
                                    <li>{{orderView?.address.shipToName}}</li>
                                    <li>{{orderView?.address.address1}}</li>
                                    <li>{{orderView?.address.address2}}</li>
                                    <li>{{orderView?.address.address3}}</li>
                                    <li>{{orderView?.address.address4}}</li>
                                    <li>{{orderView?.address.city}},
                                        {{orderView?.address.state}}
                                        {{orderView?.address.postalCode}},
                                        {{orderView?.address.country}}</li>
                                </ul>
                            </div>
                        </div>
                        @if (orderView?.shippingMethod) {
                            <div class="card">
                                <div class="card-header">
                                    <span class="pull-left" translate="cart.order.history.shipping.method"></span>
                                    <span translate="cart.order.history.shipping.date"></span>
                                </div>
                                <div class="card-body">
                                    <span [translate]="'cart.shipping.method.' + orderView?.shippingMethod.methodId"></span>
                                    @if (orderView?.packslips[0]?.shipDate) {
                                        <span>{{ orderView?.packslips[0]?.shipDate | usanadate: 'mediumDate':orderView?.warehouse?.timezone | async }}</span>
                                    }
                                </div>
                                @if (trackingCount > 0) {
                                    <div class="card-footer no-padding">
                                        <div class="card-header">
                                            <span class="pull-left tracking-header" translate="cart.order.history.order.tracking.number"></span>
                                        </div>
                                        <div class="card-body tracking-link">
                                            @for (packslip of orderView?.packslips; track packslip.packslipId) {
                                                <div class="full-width">
                                                    @for (pkg of packslip.packages; track pkg.packageId) {
                                                        <div>
                                                            <a target="_blank" href="{{pkg.trackingLink}}">
                                                                {{pkg.trackingNumber}} <i class="fa-solid fa-arrow-up-right-from-square margin-left-4" aria-hidden="true"></i>
                                                            </a>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <div class="flex-col-small order-3">
                        <div class="card">
                            <div class="card-header">
                                <span class="pull-left" translate="cart.order.history.order.summary"></span>
                            </div>

                            <div class="card-body">
                                <table class="order-summary-table">
                                    @for (taxRate of orderView?.taxRates; track $index) {
                                        <tr>
                                            <td [translate]="'cart.tax.rate'" [key]="'taxrate'" [interpolate]="taxRate.taxRate" [attr.data-testid]="'taxBreakoutTotal.' + taxRate.taxRate"></td>
                                            <td align="right">{{taxRate.taxAmount | usanacurrency: orderView?.currencyCode | async}}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <td translate="cart.order.history.order.subtotal"></td>
                                        <td align="right">{{subtotal | usanacurrency: orderView?.currencyCode | async}}</td>
                                    </tr>
                                    <tr>
                                        <td translate="cart.order.history.order.shipping"></td>
                                        @if (isShippingCostExclusiveDisplayable) {
                                            <td align="right">{{orderView?.shippingCostExclusive | usanacurrency: orderView?.currencyCode | async}}</td>
                                        } @else {
                                            <td align="right">{{orderView?.shippingCost | usanacurrency: orderView?.currencyCode | async}}</td>
                                        }
                                    </tr>
                                    @if (!orderView?.shippingTaxInclusive && orderView?.shippingTax > 0) {
                                        <tr>
                                            <td translate="cart.order.totals.shipping.tax"></td>
                                            <td align="right">{{orderView?.shippingTax | usanacurrency | async}}</td>
                                        </tr>
                                    }
                                    @if (hasOrderHandling) {
                                        <tr>
                                            <td translate="cart.order.history.order.handling"></td>
                                            <td align="right">
                                                {{orderView?.totalHandling | usanacurrency: orderView?.currencyCode | async}}
                                            </td>
                                        </tr>
                                    }
                                    @if (hasOrderTax) {
                                        <tr>
                                            <td class="product-credit-tax">
                                                <span translate="cart.order.history.order.tax"></span>@if (showProductCreditTaxDisclaimer) {<span>*</span>}
                                            </td>
                                            <td align="right">{{orderTax | usanacurrency: orderView?.currencyCode | async}}</td>
                                        </tr>
                                    }
                                    @if (hasAutoOrderDiscount) {
                                        <tr>
                                            <td class="product-info__green" translate="cart.order.ao.discount"></td>
                                            <td align="right" class="product-info__green">
                                                {{orderView?.autoOrderDiscount | usanacurrency: orderView?.currencyCode | async}}
                                            </td>
                                        </tr>
                                    }
                                    @if (hasOrderReward) {
                                        <tr>
                                            <td class="product-info__green" translate="cart.order.initial.order.reward"></td>
                                            <td align="right" class="product-info__green">
                                                {{orderView?.totalIoReward | usanacurrency: orderView?.currencyCode | async}}
                                            </td>
                                        </tr>
                                    }
                                    <tr class="summary-total bottom-border">
                                        <td translate="cart.order.history.order.total"></td>
                                        <td align="right">{{orderView?.total | usanacurrency: orderView?.currencyCode | async}}</td>
                                    </tr>
                                    @for (voucherPayment of orderView?.vouchersPayments; track voucherPayment.paymentId) {
                                        <tr>
                                            <td class="product-info__green">{{'cart.order.payment.' + voucherPayment.paymentMethodType?.toLowerCase() | translate}}</td>
                                            <td align="right" class="product-info__green">{{(voucherPayment.amount * -1) | usanacurrency: orderView?.currencyCode | async}}</td>
                                        </tr>
                                    }
                                    @for (otherPayment of orderView?.nonVouchersPayments; track otherPayment.paymentId) {
                                        <tr>
                                            <td>{{'cart.order.payment.' + otherPayment.paymentMethodType?.toLowerCase() | translate}}</td>
                                            <td align="right">{{otherPayment.amount | usanacurrency: orderView?.currencyCode | async}}</td>
                                        </tr>
                                    }
                                    @if (shouldDisplayVolume) {
                                        <tr class="order-summary">
                                            <td translate="cart.order.history.order.total.volume"></td>
                                            <td align="right">{{orderView?.totalVolume}}</td>
                                        </tr>
                                    }
                                </table>
                                @if (showProductCreditTaxDisclaimer && hasOrderTax) {
                                    <div class="product-credit-tax-disclaimer">
                                        <span translate="cart.order.totals.tax.product.credit.disclaimer"></span>
                                    </div>
                                }
                            </div>
                            @if (showPackslipBtn(orderView?.packslips)) {
                                <div class="card-footer">
                                    <div class="card-body no-padding">
                                        @for (packslip of orderView?.packslips; track packslip.packslipId) {
                                            <div class="full-width">
                                                <a class="link-default" [ngClass]="loadingPackslip ? 'isDisabled' : ''" (click)="showPackslip(orderView?.warehouse?.warehouseId, packslip.packslipId, packslip.orderId)">
                                                    <span translate="cart.order.history.packing.slip"></span>
                                                    <i class="fa-solid fa-arrow-up-right-from-square margin-left-4"></i>
                                                </a>
                                            </div>
                                        }
                                        @if (showPackslipMsg) {
                                            <div class="notification notification-alert">
                                                <p class="fw-bold margin-bottom-8">
                                                    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                                                    <span translate="cart.checkout.window.blocked.notice.title"></span>
                                                </p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
